module.exports = __webpack_public_path__ + "static/media/examplePhoto3.79cee2cc.jpeg";